import React, { useState } from 'react';
import './_aboutSlider.scss';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Mousewheel, Scrollbar } from 'swiper';
import 'swiper/components/scrollbar/scrollbar.scss';
import Popup, { showPopup } from '../popup/popup';

SwiperCore.use([Scrollbar, Mousewheel]);

function AboutSlider ({ sliderData }) {
  const [videoUrl, setVideoUrl] = useState(null);

  const swiperParams = {
    speed: 100,
    freeMode: true,
    slidesPerView: 1.15,
    scrollbar: {
      el: '.myCustomScrollbar',
      draggable: true,
      snapOnRelease: false,
      dragSize: 40,
    },
    onSlideChange,
  };

  function onSlideChange (e) {
    const endpointStyle = document.querySelector('.scrollbarEndPoint').style;
    endpointStyle.opacity = e.realIndex === e.slides.length - 1 ? 0 : 1;
  }

  function showVideoPopup (videoUrl) {
    setVideoUrl(videoUrl);
    showPopup('.aboutSliderBlock');
  }

  return (
        <div className='aboutSliderBlock'>
            <Popup parentClass='.aboutSliderBlock' videoUrl={videoUrl}/>
            <Swiper {...swiperParams}
                    mousewheel
                    breakpoints={{
                        320: {
                            spaceBetween: 20,
                        },
                        1024: {
                            spaceBetween: 70,
                        },
                    }}>
                {sliderData && sliderData.map((item, i) =>
                    <SwiperSlide key={i}>
                        <div className='sliderItem'>
                            <div className='sliderItemInfo'>
                                <h4>{item.year}</h4>
                                <p dangerouslySetInnerHTML={{ __html: item.title }}/>
                                <p className='smallText' dangerouslySetInnerHTML={{ __html: item.text }}/>
                            </div>
                            <div className={`sliderItemImage ${item.url ? 'videoImage' : ''}`}
                                 onClick={item.url ? () => showVideoPopup(item.url) : undefined}
                                 style={{ backgroundImage: `url('${!item.url ? item.image : item.thumbnail}')` }}/>
                        </div>
                    </SwiperSlide>
                )}
            </Swiper>
            <div className='scrollbarContainer'>
                <span>Explore our story</span>
                <div className='myCustomScrollbar'>
                    <div className='scrollbarEndPoint'/>
                    <div className='scrollbarStartPoint'/>
                </div>
            </div>
        </div>
  );
}

export default AboutSlider;
